import React from 'react';
import { RecommendedGoods } from '../recommendations';
import { AntifadeContainer } from 'common/components/section-vlimit/fade-container/fade-container';

type PdpSuggestionsGoodsProps = {
  placementId: string;
  productId: string;
  withDivider?: boolean;
};

export const PdpSuggestionsGoods = ({ placementId, productId, withDivider }: PdpSuggestionsGoodsProps) => {
  return (
    <>
      <AntifadeContainer />
      <RecommendedGoods
        title="Рекомендации для вас"
        _additionalProducts={[]}
        _productsLimit={20}
        placementId={placementId}
        pageType="productPlacements"
        id="suggested"
        withDivider={withDivider}
        elementBlock="recommendedProducts"
        productId={productId}
      />
    </>
  );
};
